import React from 'react';

import QuestionList from '@/components/molecules/QuestionList';
import { OnClickQuestionProps } from '@/components/molecules/QuestionList/QuestionItem';
import useRealtimeWebViewQnaViewModel from '../viewModels/useRealtimeWebViewQnaViewModel';

interface RealtimeQuestionsProps {
  onClickQuestion: ({ questionId, sectionName }: OnClickQuestionProps) => void;
  pageName: string;
}
const RealtimeWebviewQna = (props: RealtimeQuestionsProps) => {
  const viewModel = useRealtimeWebViewQnaViewModel();
  return (
    <QuestionList
      questionCard={{
        data: viewModel.questions,
        isLoading: viewModel.isQnaListLoading,
        hasNextPage: viewModel.hasNextPage,
        fetchNextPage: viewModel.fetchNextPage,
      }}
      onClickQuestion={props.onClickQuestion}
      pageName={props.pageName}
    />
  );
};

export default RealtimeWebviewQna;
